import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import DSToggleImpl from './DSToggleImpl.js';
import { d as dsBasicSizes } from '../prop-types-cc01d273.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import './toggleHelper.js';
import './DSToggleRender.js';
import '@elliemae/ds-utilities/onClickHandlerForNonInteractiveElements';
import '@elliemae/ds-classnames';
import '@elliemae/ds-tooltip';
import './props.js';
import 'prop-types';

var DSToggle = function DSToggle(_ref) {
  var containerProps = _ref.containerProps,
      hasError = _ref.hasError,
      readOnly = _ref.readOnly,
      disabled = _ref.disabled,
      checked = _ref.checked,
      labelOn = _ref.labelOn,
      labelOff = _ref.labelOff,
      name = _ref.name,
      value = _ref.value,
      size = _ref.size,
      otherProps = _objectWithoutProperties(_ref, ["containerProps", "hasError", "readOnly", "disabled", "checked", "labelOn", "labelOff", "name", "value", "size"]);

  return /*#__PURE__*/React.createElement(DSToggleImpl, _extends({}, otherProps, {
    checked: checked,
    containerProps: containerProps,
    disabled: disabled,
    hasError: hasError,
    labelOff: labelOff,
    labelOn: labelOn,
    name: name,
    readOnly: readOnly,
    size: size,
    value: value
  }));
};

DSToggle.defaultProps = {
  labelOn: 'ON',
  labelOff: 'OFF',
  size: 's',
  hasError: false,
  readOnly: false,
  disabled: false,
  checked: undefined
};
var props = {
  /**
   * Set of Properties attached to the main container
   */
  containerProps: PropTypes.shape({}).description('Set of Properties attached to the main container'),

  /**
   * Whether the toggle has error or not
   */
  hasError: PropTypes.bool.description('Whether the toggle has error or not'),

  /**
   * Whether the toggle is read only or not
   */
  readOnly: PropTypes.bool.description('Whether the toggle is read only or not'),

  /**
   * Whether the toggle is disabled or not
   */
  disabled: PropTypes.bool.description('Whether the toggle is disabled or not'),

  /**
   * Whether the toggle is checked or not
   */
  checked: PropTypes.bool.description('Whether the toggle is checked or not'),

  /**
   * Allows a function that is triggered once the toggle changes
   */
  onChange: PropTypes.func.description('Allows a function that is triggered once the toggle changes'),

  /**
   * Label to show when the toggle is ON
   */
  labelOn: PropTypes.string.description('Label to show when the toggle is ON'),

  /**
   * Label to show when the toggle is OFF
   */
  labelOff: PropTypes.string.description('Label to show when the toggle is OFF'),

  /**
   * Default value once the component is initialized
   */
  value: PropTypes.string.description('Default value once the component is initialized'),

  /**
   * ['s', 'm', 'l']
   */
  size: PropTypes.oneOf(dsBasicSizes).description("['s', 'm', 'l']"),

  /**
   * Input name
   */
  name: PropTypes.string.description('Input name')
};
DSToggle.propTypes = props;
var DSToggleWithSchema = describe(DSToggle);
DSToggleWithSchema.propTypes = props;

export default DSToggle;
export { DSToggleWithSchema };
//# sourceMappingURL=DSToggle.js.map
